<template>
  <div>
    <ModalViewRRIM v-if="this.$store.getters.$GetModalCancel.rrimView" />
    <!-- Inicializando Tabela -->
    <div class="filters">
      <div class="searchInput">
        <div class="icon">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjY4NzIgMTkuMjg3TDE4LjIwODIgMTQuOTQzNEMxOC4wMDYgMTQuNzQ3NCAxNy43MzIgMTQuNjM4NCAxNy40NDQ0IDE0LjYzODRIMTYuNzEyMkMxNy45NTIxIDEzLjEwMDUgMTguNjg4OSAxMS4xNjYyIDE4LjY4ODkgOS4wNjE4OUMxOC42ODg5IDQuMDU2MDcgMTQuNTA2MyAwIDkuMzQ0NDMgMEM0LjE4MjUzIDAgMCA0LjA1NjA3IDAgOS4wNjE4OUMwIDE0LjA2NzcgNC4xODI1MyAxOC4xMjM4IDkuMzQ0NDMgMTguMTIzOEMxMS41MTQzIDE4LjEyMzggMTMuNTA5IDE3LjQwOTMgMTUuMDk0OSAxNi4yMDY4VjE2LjkxN0MxNS4wOTQ5IDE3LjE5NTggMTUuMjA3MiAxNy40NjE2IDE1LjQwOTMgMTcuNjU3NkwxOS44ODg0IDIyLjAwMTJDMjAuMzEwNyAyMi40MTA4IDIwLjk5MzUgMjIuNDEwOCAyMS40MTEzIDIyLjAwMTJMMjIuNjgyNyAyMC43NjgzQzIzLjEwNSAyMC4zNTg4IDIzLjEwNSAxOS42OTY1IDIyLjY4NzIgMTkuMjg3Wk05LjM0NDQzIDE0LjYzODRDNi4xNjgyMiAxNC42Mzg0IDMuNTk0MDEgMTIuMTQ2NCAzLjU5NDAxIDkuMDYxODlDMy41OTQwMSA1Ljk4MTcyIDYuMTYzNzMgMy40ODUzNCA5LjM0NDQzIDMuNDg1MzRDMTIuNTIwNiAzLjQ4NTM0IDE1LjA5NDkgNS45NzczNiAxNS4wOTQ5IDkuMDYxODlDMTUuMDk0OSAxMi4xNDIxIDEyLjUyNTEgMTQuNjM4NCA5LjM0NDQzIDE0LjYzODRaIiBmaWxsPSIjNkM2QzZDIi8+Cjwvc3ZnPgo="
            alt=""
          />
        </div>
        <div>
          <input
            style="border: none !important"
            type="text"
            placeholder="Pesquisar..."
            v-model="value_filter"
          />
        </div>
      </div>
      <div>
        <div class="filter-content">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjgyNyAwSDEuMTczMjRDMC4xMzIzMTkgMCAtMC4zOTI5MjUgMS4wODg5IDAuMzQ0NjI0IDEuNzI0NzhMOS4zNzUgOS41MTE1OFYxOC4xODYyQzkuMzc1IDE4LjUxNTggOS41NjE1NyAxOC44MjQ4IDkuODc0ODUgMTkuMDEzOUwxMy43ODExIDIxLjM3MDVDMTQuNTUxOCAyMS44MzU2IDE1LjYyNSAyMS4zNjQyIDE1LjYyNSAyMC41NDI4VjkuNTExNThMMjQuNjU1NiAxLjcyNDc4QzI1LjM5MTYgMS4wOTAxNiAyNC44NyAwIDIzLjgyNyAwWiIgZmlsbD0iIzQ0NDQ0NCIvPgo8L3N2Zz4K"
            alt=""
          />
          <div class="content-intern">
            <select v-model="filter_attr">
              <option value="Todos">Todos</option>
              <option value="id">Id</option>
              <option value="client">Cliente</option>
              <option value="mold">Molde</option>
            </select>
          </div>
        </div>
      </div>

      <button class="btn-filter" @click="filter">Filtrar</button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <td colspan="col">RRIM</td>
          <td colspan="col">Molde</td>
          <td colspan="col">Cliente</td>
          <td colspan="col">Tipo de Molde</td>
          <td colspan="col">Data de Criação</td>
          <td colspan="col">Data de Abertura</td>
          <td colspan="col">Data de Tryout</td>
          <td colspan="col">Aprovado por:</td>
          <td colspan="col">Opções</td>
        </tr>
      </thead>
      <tbody class="tb-content">
        <tr v-for="tryouts in filtrarInput()" :key="tryouts.id">
          <td data-label="N° RRIM" class="tdTitle">{{ tryouts.rrim }}</td>
          <td data-label="N° Molde">{{ tryouts.molde }}</td>
          <td data-label="Cliente">{{ tryouts.Cliente }}</td>
          <td data-label="molde">
            <span v-if="tryouts.molde_family === 'true'"> Molde Familia</span>
            <span v-else> Molde Normal</span>
          </td>
          <td data-label="Data de Criação">{{ tryouts.Data }}</td>
          <td data-label="Data de Abertura">{{ tryouts.DataAbertura }}</td>
          <td data-label="Data de Tryout">{{ tryouts.DatadeTryout }}</td>
          <td data-label="Aprovado por:">
            {{ tryouts.homologado }} <br />{{ tryouts.cargo }}
          </td>
          <td data-label="Opções">
            <div class="buttons-group">
              <button
                class="button3"
                type="button"
                @click="modal_view(tryouts.rrim)"
              >
                <i class="fas fa-eye"> </i>
                Visualizar
              </button>
              <button
                class="button5"
                type="button"
                @click="exportar(tryouts.rrim)"
              >
                <i class="fas fa-file-export"> </i>
                Exportar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <h2 v-if="filtrarInput().length === 0">Não há nada para ser mostrado</h2>

    <div style="display: flex; gap: 5px; align-items: center; height: 4rem">
      <button @click="init" v-if="currentPage !== 0" class="btn-pagination">
        Inicio
      </button>
      <button @click="back" v-if="currentPage !== 0" class="btn-pagination">
        Voltar
      </button>
      <span class="count"> Página {{ countPage }} de {{ countTotal }}</span>

      <button
        @click="next"
        class="btn-pagination"
        v-if="filtrarInput().length !== 0"
      >
        Próximo
      </button>
    </div>
  </div>
</template>

<script>
import TableLite from "./../../components/Tables/Table-Simple.vue";
import {
  GetFindDataByIdRRIM,
  GetFindDataRRIMByAttr,
} from "../../controllers/RRIM/GetFindDataByIdRRIM";
import ModalViewRRIM from "../../components/Modais/ModalRRIM/ModalViewRRIM.vue";
import ModalEditRRIM from "../../components/Modais/ModalRRIM/ModalEditRRIM.vue";
import { GetAllRrimInAprovados } from "../../controllers/RRIM/GetAllRrimInAprovado";
import dayjs from "dayjs";

// Orden de dados em forma Crescente
const sampleData1 = (offst, limit) => {
  offst = offst + 1;

  let data = [];
  for (let i = offst; i <= limit; i++) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

//Orden de dados em forma Decrescente
const sampleData2 = (offst, limit) => {
  let data = [];
  for (let i = limit; i > offst; i--) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

export default {
  name: "App",
  components: { TableLite, ModalViewRRIM, ModalEditRRIM },

  props: {
    configInputs: Number,
    role: String,
  },
  mounted() {
    if (this.role === "eng_analista" || this.role === "eng_admin") {
      this.autho = true;
    }
  },
  async created() {
    // this.$store.commit("SetLoadingPattern", true); // insere o loading

    await this.requestList();
    // this.$store.commit("SetLoadingPattern", false); // insere o loading
  },
  data() {
    return {
      value_filter: null,
      filter_attr: "Todos",
      autho: String,
      Data: [],
      valueSearch: "",
      VerifyRRIM: false,
      dataLenght: 0,
      VerifyEditRRIM: this.$store.getters.$GetModalCancel.rrimEdit,
      isLoading: false,
      rows: [],
      rowsNowOk: [],
      totalRecordCount: 0,
      totalRecordCountNok: 0,
      sortable: {
        order: "id",
        sort: "asc",
      },
      currentPage: 0,
      countPage: 1,
      countTotal: 0,
    };
  },

  methods: {
    async requestList() {
      this.isLoading = true;
      this.$store.commit("SetLoadingPattern", true); // insere o loading
      this.Data = [];
      const result = await GetAllRrimInAprovados(this.currentPage, 10, 1);
      await result.list.map((element) => {
        this.Data.push({
          rrim: element.ID,
          homologado: `${element.homologacao[0].homologation_user.nome}`,
          cargo: element.homologacao[0].homologation_user.cargo,
          molde: element.MOLDE,
          molde_family: element.molde_familia,
          Cliente: element.CLIENTE,
          Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
          DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
          DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
        });
      });
      console.log(this.countTotal);
      this.countTotal = result.countTotal / 10;
      if (!Number.isInteger(this.countTotal)) {
        const npage = Math.round(this.countTotal);
        this.countTotal = npage;
      }
      this.dataLenght = result.length;
      this.$store.commit("SetLoadingPattern", false); // insere o loading
      await this.doSearch(0, 10, "description", "asc");
    },
    async filter() {
      if (this.filter_attr == "Todos") {
        await this.requestList();
      } else {
        const result = await GetFindDataRRIMByAttr(
          this.filter_attr,
          this.value_filter,
          2
        );

        this.Data = [];
        await result.data.map((element) => {
          this.Data.push({
            rrim: element.ID,
            homologado: `${element.homologacao[0].homologation_user.nome}`,
            cargo: element.homologacao[0].homologation_user.cargo,
            molde: element.MOLDE,
            Cliente: element.CLIENTE,
            Data: this.ReformDate(element.DT_CHEGADA_MOLDE),
            DataAbertura: this.ReformDate(element.DT_ABERTURA_MOLDE),
            DatadeTryout: this.ReformDate(element.DT_TRYOUT_MOLDE),
          });
        });
      }
    },

    async init() {
      this.currentPage = 0;
      this.countPage = 1;
      await this.requestList();
    },

    async back() {
      this.currentPage = this.currentPage - 10;
      this.countPage--;
      await this.requestList();
    },

    async next() {
      this.currentPage = this.currentPage + 10;
      this.countPage++;
      await this.requestList();
    },

    async modal_view(rrim) {
      const result = await GetFindDataByIdRRIM(rrim);
      await this.$store.commit("MutationGetFindDataRRIM", result.data);
      this.$store.commit("MutationSetCancelModalViewRRIM", true);
    },
    // Montagem de filro e limite do checklist
    doSearch(offset, limit, order, sort) {
      if (!this.isLoading) {
        this.isLoading = true;
      }
      setTimeout(() => {
        const limitePre = this.dataLenght;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rows = sampleData1(offset, limit);
        } else {
          this.rows = sampleData2(offset, limit);
        }

        this.totalRecordCount = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    // Montagem de filro e limite de Itens Não/Ok
    doSearch_NaoOK(offset, limit, order, sort) {
      // this.isLoadingNok = true;
      setTimeout(() => {
        const limitePre = this.Data.length;

        this.isReSearch = offset == undefined ? true : false;

        if (offset >= limit) {
          if (offset + limit > limitePre) {
            limit = limitePre;
          } else {
            limit = offset + limit;
          }
        }

        if (limit >= limitePre) {
          limit = limitePre;
        }

        if (sort == "asc") {
          this.rowsNowOk = sampleData1(offset, limit);
        } else {
          this.rowsNowOk = sampleData2(offset, limit);
        }

        this.totalRecordCountNok = limitePre;
        this.sortable.order = order;
        this.sortable.sort = sort;
      }, 600);
    },

    ReformDate(date) {
      const data = dayjs(date).add(1, "day").format("DD/MM/YYYY");

      return data;
    },

    async exportar(id) {
      const toast = await this.$swal
        .fire({
          title: "Deseja exportar RRIM?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const exportDocument = await this.$router.resolve({
        path: "/export",
        query: { id },
      });
      window.open(exportDocument.href, "_blank");
    },
    filtrarInput() {
      let list = [];
      this.valueSearch = this.valueSearch.toLocaleLowerCase();
      list = this.Data.filter((filter) => {
        let rrimCodeFormated = String(filter.rrim);
        return (
          rrimCodeFormated.toLowerCase().match(this.valueSearch) ||
          filter.molde.toLowerCase().match(this.valueSearch) ||
          filter.Cliente.toLowerCase().match(this.valueSearch) ||
          filter.homologado.toLowerCase().match(this.valueSearch)
        );
      });
      return list;
    },
  },
};
</script>
<style scoped>
input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}
img {
  border-style: none;
}

.searchInput {
  margin-top: 10px;
  width: 400px;
  background-color: var(--white);
  height: 2.8rem;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid var(--gray_text);
}
.btn-pagination {
  border: none;
  background-color: var(--green);
  padding: 0.5rem;
  color: var(--white);
  border-radius: 0.25rem;
}

.filter-content .content-intern {
  width: 80%;
  padding: 0 0 0 5px;
}

.filter-content .content-intern select {
  width: 100%;
  border: none;
  font-size: 15px;
  text-align: left;
}
.filters {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-filter {
  width: 70px;
  height: 2.8rem;
  background-color: var(--green);
  color: #fff;
  border-radius: 0.25rem;
}
.searchInput .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.searchInput input {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  width: 100%;
  border: none;
  border-radius: 5px;
}

.searchInput ::placeholder {
  color: #9a9a9a;
  font-weight: bold;
  letter-spacing: 0.2rem;
}

table {
  border-collapse: collapse;
  max-height: 400px;
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 1.5rem;
}

thead {
  font-size: 16px;
  background-color: var(--green);
  color: #fff;
  border-radius: 5px;
}

th {
  padding: 10px;
  border-top: none;
  border-left: none;
}

td {
  padding: 10px;
  border-left: none;
  font-size: 14px;
}

.btn {
  display: flex;
  gap: 1rem;
  margin-left: 16px;
  margin-bottom: -11px;
}

.btn button {
  width: 22px;
  height: 22px;
  background: transparent;
}

.input-tamanho {
  width: 100%;
  height: 40px;
  border: none;
  padding: 3px;
}

.maozinha {
  cursor: pointer;
}

.red {
  color: var(--red) !important;
}

.error {
  background: var(--redTransparent);
}

.buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.button3 {
  background: var(--white);
  color: var(--orange);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button3:hover {
  background: var(--orange);
  color: var(--white);
}

.button4 {
  background: var(--white);
  color: var(--blue);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button4:hover {
  background: var(--blue);
  color: var(--white);
}

.filter-content {
  height: 2.8rem;
  width: 200px;
  background-color: var(--white);
  display: flex;
  align-items: center;
  border: 1px solid var(--gray_text);
  border-radius: 5px;
  padding: 0 0 0 5px;
}
.button5 {
  background: var(--white);
  color: var(--green);
  padding: 4px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button5:hover {
  background: var(--green);
  color: var(--white);
}

@media (max-width: 600px) {
  .inputSearch {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .searchInput input {
    width: 100%;
  }
  .table thead {
    clip: react(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  tbody {
    background: none;
  }
  .table tr {
    border: 1px solid var(--gray_text);
    border-radius: 7px;
    display: block;
    margin-bottom: 2rem;
    padding: 0;
    background: var(--white);
  }
  .table td {
    display: block;
    font-size: 1rem;
    text-align: right;
  }
  .table td::before {
    content: attr(data-label);
    float: left;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.9rem;
  }

  .buttons-group {
    justify-content: flex-end;
  }
}
</style>

